import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { dataSummary } from "@/api/dataAll/dataSummary";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { getafLinksList, deleafLinks } from "@/api/dataAll/afdetectLinks";
import addafLinks from "./components/addafPamseMange";
import clipboard from '@/utils/clipboard';
export default {
  name: "afDetectLinks",
  components: {
    addafLinks: addafLinks
  },
  data: function data() {
    return {
      tableTitle: [],
      gameId: "",
      value1: "",
      total: 0,
      pagrSize: 10,
      disabled: true,
      sels: [],
      selsString: '',
      addWayConfig: false,
      searchData: {
        page: 1,
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      showing: false,
      searchMark: {
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: []
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    }); // getCountry().then((res) => {
    //   this.searchpcountry = res.data;
    // });
  },
  methods: {
    searchClick: function searchClick() {
      var _this2 = this;

      this.searchMark.kind = 1;
      getafLinksList(this.searchMark).then(function (res) {
        _this2.tableData = res.data.data || [];
        _this2.total = res.data.total - 0 || 0;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this3.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleSource: function handleSource(id, num) {
      var _this4 = this;

      this.addWayConfig = true;
      this.showing = true;
      this.$nextTick(function () {
        _this4.$refs.addWayConfig.init(id, num);
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      clipboard(text, event);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchData.page = val;
      this.searchClick();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    deleAll: function deleAll() {
      var _this5 = this;

      this.$confirm("此操作将删除此监测链接, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleafLinks({
                  id: _this5.selsString
                }).then(function (res) {
                  _this5.searchClick();
                });

                _this5.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      this.$confirm("此操作将删除该监测链接, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deleafLinks({
                  id: id
                }).then(function (res) {
                  _this6.searchClick();
                });

                _this6.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};